import { render } from "./AccountsReceivable.vue?vue&type=template&id=4a49d05c"
import script from "./AccountsReceivable.vue?vue&type=script&lang=js"
export * from "./AccountsReceivable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__